"use client";

import { useMemo, useState } from "react";

import { ToolFrame } from "@/components/tools/ToolFrame";

export function DeadStockAgingScorerClient() {
  const [onHand, setOnHand] = useState(180);
  const [monthlySales, setMonthlySales] = useState(25);
  const [monthsSinceLastSale, setMonthsSinceLastSale] = useState(2);
  const [monthsToExpiry, setMonthsToExpiry] = useState(7);

  const score = useMemo(() => {
    const cover = monthlySales > 0 ? onHand / monthlySales : 999;
    let s = 0;
    if (cover > 8) s += 45;
    else if (cover > 5) s += 30;
    else if (cover > 3) s += 15;
    if (monthsSinceLastSale >= 3) s += 25;
    if (monthsToExpiry <= 3) s += 20;
    else if (monthsToExpiry <= 6) s += 10;
    return Math.min(100, s);
  }, [onHand, monthlySales, monthsSinceLastSale, monthsToExpiry]);

  const level = score >= 70 ? "High" : score >= 40 ? "Medium" : "Low";

  return (
    <ToolFrame
      toolKey="dead-stock-aging-scorer"
      title="Dead-Stock Aging Scorer"
      embedPath="/embed/dead-stock-aging-scorer"
      exportCsvRows={[{ onHand, monthlySales, monthsSinceLastSale, monthsToExpiry, score, riskLevel: level }]}
    >
      <div className="ed-card-glass" style={{ maxWidth: "520px", padding: "1rem", borderRadius: "12px", display: "grid", gap: ".65rem" }}>
        <Field label="On-hand units" value={onHand} onChange={setOnHand} />
        <Field label="Avg monthly sales" value={monthlySales} onChange={setMonthlySales} />
        <Field label="Months since last sale" value={monthsSinceLastSale} onChange={setMonthsSinceLastSale} />
        <Field label="Months to expiry / obsolescence trigger" value={monthsToExpiry} onChange={setMonthsToExpiry} />
        <div style={{ marginTop: ".35rem", borderTop: "1px solid rgba(148,163,184,.25)", paddingTop: ".7rem" }}>
          <p style={{ margin: "0 0 .2rem", color: "#64748b", fontSize: ".8rem" }}>Aging risk score</p>
          <p style={{ margin: 0, color: "#0c4a6e", fontSize: "1.5rem", fontWeight: 900 }}>{score}/100 ({level})</p>
        </div>
      </div>
    </ToolFrame>
  );
}

function Field({ label, value, onChange }: { label: string; value: number; onChange: (v: number) => void }) {
  return (
    <label style={{ display: "grid", gap: ".3rem", fontSize: ".85rem", color: "#475569" }}>
      {label}
      <input
        type="number"
        value={value}
        onChange={(e) => onChange(Number(e.target.value || 0))}
        style={{ width: "100%", padding: ".55rem .65rem", borderRadius: "8px", border: "1px solid rgba(148,163,184,.45)", boxSizing: "border-box" }}
      />
    </label>
  );
}

